<template>
  <div class="generate-app">
    <div class="generate-app-details">
      
      <h1 v-show="!hasDownloadLink && !downloadLinkBroken">Generating code</h1>

      <h1 v-show="downloadLinkBroken">Sorry about that</h1>
      <h4 v-show="downloadLinkBroken">We couldn't generate at this time. Contact the <a href="https://twitter.com/filledstacks">dev on twitter</a></h4>

       <h1 v-show="hasDownloadLink">All Done</h1>
      <h4 v-show="hasDownloadLink">Your code is ready. Thank you for trying this tool.</h4>
      <!--  -->
        <div class="loading-container" v-show="!hasDownloadLink && !downloadLinkBroken">
            <circle6 class="loading-indicator"></circle6>
        </div>

      <p v-show="!hasDownloadLink && !downloadLinkBroken">Please wait a moment while the server is generating your code skeleton for you.</p>
      <p v-show="!hasDownloadLink && !downloadLinkBroken"
      >I really appreciate you using this product.</p>

      <p v-show="downloadLinkBroken">
        This tool is built and maintained by only
        <a href="https://twitter.com/filledstacks">Me</a>. Tweet me and I will get back to you as soon as possible, maximum time 48 hours.
      </p>
        <p v-show="hasDownloadLink">Your app is ready. Please download below and follow the instructions in the Readme to get started.</p>
        <p v-show="hasDownloadLink">I would appreciate a share on twitter or reddit. Tag me @filledstacks on all the platforms</p>
      <a v-show="hasDownloadLink" :href="appDownloadLink">
        <button>Download Code</button>
      </a>
      <button v-show="hasDownloadLink" class="invert-cta" @click="navigateToDashboard">Dashboard</button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { Circle6 } from 'vue-loading-spinner';

export default {
  name: "GenerateApp",
  components: {
    Circle6
  },
  mounted() {
    this.fetchUserApps();
    this.setFooterState(0);
  },
  computed: {
    ...mapState(["appDownloadLink", "appPackageName"]),
    downloadLinkBroken() {
      return typeof this.appDownloadLink != "string";
    },
    hasDownloadLink() {
      return this.appDownloadLink != "" && !this.downloadLinkBroken;
    },
    fileDownloadName() {
      return this.appPackageName + ".zip";
    }
  },
  methods: {
    ...mapActions(["fetchUserApps", "setFooterState"]),
    navigateToDashboard() {
      this.$router.replace("dashboard");
    }
  },
  watch: {
    downloadLinkBroken: function(value) {
      if(value && value === true) {
        this.$modal.show("info-modal", {
          title: "Generation failed",
          message: `We could not generate your app for you at this time. Please report this to us so that we can fix it.`
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>

h4 {
  font-size: 35px;
  margin: 0;
  padding: 0;
  margin-top: 20px;
  text-transform: uppercase;
  line-height: 35px;
}

.generate-app {
  display: grid;
  height: 80vh;
}

$generate-content-width: 450px;

.generate-app-details {
  width: $generate-content-width;
  height: 400px;
  justify-self: center;
  align-self: center;
}

.loading-container {
    display: grid;
    width: $generate-content-width;
    margin-top: 45px;    
}

.loading-indicator {
   justify-self: center;
}

button {
    margin-top: 60px;
}

.invert-cta {
  // margin-left:20px;
  float: right;
}



h1 {
  line-height: 60px;
  text-align: center;
}

a {
  text-decoration: none;
  text-align: center;
  div {
    width: 230px;
    padding-top: 15px;
  }
}

p {
  margin-top: 50px;
  font-weight: 400;
  font-size: 15px;
  text-align: center;
}
</style>
